<template>

    <div class="py-4 px-5">
        <div class="form-group row">
            <label for="email" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Profile Picture</label>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-md-6">
                        <img src="static/unknown-profile.png" class="user-profile" v-if="data.imageData == null">
                        <img :src="data.imageData" class="user-profile" v-if="data.imageData !== null">
                    </div>
                    <div class="col-md-6 d-flex justify-content-center align-items-center">
                        <label class="btn btn-primary mt-3 mb-3">
                            Select a picture
                            <input type="file" @change="previewImage" accept="image/*" style="display: none">
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row mt-5">
            <label for="email" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Email</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="email" :value="$store.state.auth.userInfo.email" disabled>
            </div>
        </div>
        <div class="form-group row">
            <label for="password" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Password</label>
            <div class="col-sm-9">
                <input type="password" class="form-control" id="password" disabled value="password">
            </div>
        </div>

        <div class="form-group row mt-5">
            <label for="name" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Name</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="name" placeholder="John Doe" :value="$store.state.auth.userInfo.name" disabled>
            </div>
        </div>

        <div class="form-group row">
            <label for="address" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Address</label> 
            <div class="col-sm-9">
                <input type="text" placeholder="3983 Example Street" class="form-control" v-model="data.address">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-3"></div>
            <div class="col-md-5 form-group">
                <input type="text" placeholder="Childersbugh" class="form-control" v-model="data.city">
            </div>
            <div class="col-md-2 form-group">
                <input type="text" placeholder="AL" class="form-control" v-model="data.state">
            </div>
            <div class="col-md-2 form-group">
                <input type="number" placeholder="35044" class="form-control" v-model="data.zipcode">
            </div>
        </div>


        <div class="form-group row">
            <label for="phone" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Phone Number</label> 
            <div class="col-sm-9">
                <input type="number" id="phone" placeholder="123-456-7890" class="form-control" v-model="data.phone">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12 text-right mt-4">
                <button class="btn btn-secondary mr-3" v-on:click="previous">Previous</button>
                <button class="btn btn-primary" v-on:click="next">
                    <span v-if="!loading">Next</span>
                    <span v-if="loading"><i class="fa fa-circle-o-notch fa-spin"></i></span>
                </button>
            </div>
        </div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';

	export default {
        name: 'Account',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                data: {
                    address: null,
                    city: null,
                    state: null,
                    zipcode: null, 
                    phone: null,
                    imageData: null,
                },
                loading: false,
			}
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            previous() {
                var data = {
                    at: 'account',
                    direction: 'backward',
                }
                EventBus.$emit('account-setup-navigation', data)
            },
            next() {
                this.loading = true;

                var data = {
                    at: 'account',
                    direction: 'forward',
                }

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/user/settings/update", this.data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        this.loading = false;
                        EventBus.$emit('account-setup-navigation', data)

                    } else {
                        this.loading = false;
                        alert('There has been an issue. Please try again.');
                    }
                });


            },

            previewImage: function(event) {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.data.imageData = e.target.result;
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(input.files[0]);
                }
            },
        }
    }

</script>



<style scoped>

    .user-profile {
        width: 125px;
        height: 125px;
        margin: 0 auto;
        background-color: #000;
        border-radius: 50%
    }


</style>
